module.exports = __webpack_public_path__ + "static/img/step1.da67507c.png";